module.exports = __webpack_public_path__ + "7d45af2ef3159f250734a46b5a418bd5.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/assets/jacktop_roulette.png
// module id = 1685
// module chunks = 2